import { render, staticRenderFns } from "./number-filter.vue?vue&type=template&id=5f017bb1"
import script from "./number-filter.ts?vue&type=script&lang=js&external"
export * from "./number-filter.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports